<template>
    <modal name="show-product-modal" @before-open="beforeOpen" :draggable="true" :resizable="true" transition="pop-out"
           :width="800"
           :height="'auto'">
        <h4 class="text-center panel-heading">{{product.dutchTitle}}</h4>
        <form @submit.prevent="orderProduct()">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div v-if="product.imageLocation" class="col-sm-12">
                        <img :src="BACKEND_BASE_URL + '/images/' + product.imageLocation" width="150">
                    </div>
                    <div v-if="!product.imageLocation" class="col-sm-12">
                        <span><i>{{$t("no_picture_available")}}</i></span>
                    </div>
                </div>
            </div>
            <div v-if="product.documentLocation" class="row">
                <div class="col-sm-12 text-center">
                    <div  class="col-sm-12">
                        <a :href="BACKEND_BASE_URL + '/documents/' + product.documentLocation" target="_blank">{{$t("download_document")}}</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12" style="margin-top: 20px">
                    <div :class="loggedInCustomer.showPrices ? 'col-sm-offset-7 col-sm-1' : 'col-sm-offset-6 col-sm-1'">
                        <label>{{$t("discount")}}</label>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div>
                        <div class="col-sm-6" style="margin-top:7px; margin-bottom:15px;">
                            <strong>{{ getLocale() == 'nl' ? product.dutchTitle : product.frenchTitle}} ({{product.articleNumber}})</strong>
                            <p>{{ getLocale() == 'nl' ? product.dutchDescription : product.frenchDescription}}</p>
                        </div>
                        <div class="col-sm-1" style="margin-top: 7px; white-space: nowrap" v-if="loggedInCustomer.showPrices">
                            €{{parseFloat(product.price).toFixed(2)}}
                            <span v-if="product.customPrice"><i class="glyphicon glyphicon-info-sign" v-tooltip="'speciale prijs'"></i></span>
                        </div>
                        <div class="col-sm-1" style="margin-top: 7px;">
                            {{discount ? discount : 0}}%
                        </div>
                        <div class="col-sm-2">
                            <input title="amount" type="number" min="1" step="1" class="form-control" v-model="amount">
                        </div>
                        <div class="col-sm-2">
                            <button type="submit" class="btn btn-info">{{shouldUpdate ? $t("update") : $t("order")}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'

    export default {
        name: 'ShowProduct',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
                amount: '',
                discount: '',
                shouldUpdate: false,
                file: null
            }
        },
        methods: {
            orderProduct() {
                this.product.amount = parseInt(this.amount)
                if (isNaN(this.product.amount)) {
                    this.product.amount = 1
                }
                this.product.discount = parseFloat(this.discount)
                if (this.shouldUpdate) {
                    this.$store.commit(types.EDIT_PRODUCT_IN_SHOPPING_CART, this.product)
                    this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Winkelwagen is aangepast!' })
                } else {
                    this.$store.commit(types.ADD_PRODUCT_TO_SHOPPING_CART, this.product)
                    this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                    if (this.getLocale() === 'nl') {
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is toegevoegd aan je winkelwagen!' })
                    } else {
                        this.$notify({ group: 'success', type: 'success', title: 'Succès', text: 'Le produit a été ajouté à votre panier!' })
                    }
                }
                this.$modal.hide('show-product-modal')
                this.amount = ''
                this.shouldUpdate = false
            },
            getLocale() {
                return this.$i18n.locale
            },
            beforeOpen(event) {
                if (event.params.productId) {
                    this.$store.dispatch('getProduct', event.params.productId).then(() => {
                        if (event.params.amount) {
                            this.shouldUpdate = true
                            this.amount = event.params.amount
                            this.discount = event.params.discount
                        }
                    })
                }
                if (this.loggedInCustomer.id) {
                    this.$store.dispatch('getDiscounts').then(() => {
                        this.discounts.forEach((discount) => {
                            if (this.product.categoryCode === discount.code) {
                                this.discount = discount.discount
                            }
                        })
                        this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                            this.customerSpecificPrices.forEach((customerSpecificPrice) => {
                                if (this.product.articleNumber === customerSpecificPrice.articleNumber) {
                                    this.discount = 0
                                    this.product.price = customerSpecificPrice.price
                                    this.product.customPrice = true
                                }
                            })
                        })
                    })
                }
            }
        },
        computed: {
            ...mapGetters({
                product: 'product',
                loggedInCustomer: 'loggedInCustomer',
                discounts: 'discounts',
                customerSpecificPrices: 'customerSpecificPrices',
            })
        }
    }
</script>

<style scoped>
</style>
